<template>
  <section
    class="content d-none d-md-block"
    id="tabSection"
  >
    <div>
      <tabs
        :options="{ useUrlFragment: false }"
        @changed="selectedTab"
        cache-lifetime="0"
      >
        <div
          v-for="(category, index) in getCategoryData.slice(0,4)"
          :key="index"
        >
          <tab
            :id="'tabSectionTitle'+index"
            :name="category.category_name"
												:data-test="'tabSectionTitle'+index"
          >
            <div class="prdt-tab-link">
              <div class="owl-two owl-carousel owl-theme owl-loaded">
                <div class="owl-stage-outer">
                  <div class="owl-stage">
                    <div
                      class="owl-item"
                      v-for="(sub_categories, index) in category.sub_categories"
                      :key="sub_categories.category_id"
                      @click.prevent="getCategory(sub_categories)"
																						:data-test="'tabSectionSubCategory'+index"
																						:id="'tabSectionSubCategory'+index"
                    >
                      <div class="prdt-tab">
                        <div class="prdt-tab-text-cont">
                          <h5
                            class="prdt-tab-text"
																												:data-test="'tabSectionSubCategoryName'+index"
																												:id="'tabSectionSubCategoryName'+index"
                          >
                            {{sub_categories.category_name}}
                          </h5>
                        </div>
                        <div class="prdt-tab-img-cont">
                          <img
                            class="prdt-tab-img"
                            v-lazy="sub_categories.background_image"
                            alt="Categories Tab Image"
                            srcset=""
                            :id="'tabSectionSubCategoryImg'+index"
																												:data-test="'tabSectionSubCategoryImg'+index"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab>
        </div>
      </tabs>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('category', ['getCategoryData'])
	},
	methods: {
		selectedTab (selectedTab) {
			if (this.getCategoryData[0].category_name !== selectedTab.tab.name) {
				const categoryStyleData = document.getElementsByName(this.getCategoryData[0].category_name)
				if (categoryStyleData && categoryStyleData.style) {
					categoryStyleData.style.display = 'none'
				}
				const tabsComponentTabClassList = document.getElementsByClassName('tabs-component-tab')
				if (tabsComponentTabClassList && tabsComponentTabClassList[0] &&
          tabsComponentTabClassList[0].classList &&
          tabsComponentTabClassList[0].classList.contains('is-active')) {
					document.getElementsByClassName('tabs-component-tab')[0].classList.remove('is-active')
				}
			}
		},
		getCategory (classifications) {
			this.$nextTick(() => {
				this.$router.push({
					name: 'ProductList',
					path: '/product-list',
					query: {
						category: classifications.category_id,
						display_text: classifications.category_name,
						name: classifications.category_name,
						is_a_category: true,
						depth: 2
					}
				})
			})
		}
	},
	mounted () {
		setTimeout(() => {
			if (this.getCategoryData.length > 0) {
				const categoryData = document.getElementsByName(this.getCategoryData[0].category_name)
				if (categoryData && categoryData.style) {
					categoryData.style.display = 'block'
					document.getElementsByClassName('tabs-component-tab')[0].classList.add('is-active')
				}
			}
		}, 3000)
		/* Mount the Owl carousel */
		$('.owl-two').owlCarousel({
			rtl: false,
			loop: false,
			margin: 10,
			dots: false,
			stagePadding: 24,
			lazyLoad: true,
			nav: false,
			responsive: {
				0: {
					items: 2,
					nav: true
				},
				576: {
					items: 2,
					nav: false
				},
				768: {
					items: 2,
					nav: false
				},
				992: {
					items: 3,
					nav: false
				},
				1200: {
					items: 3,
					nav: true
				},
				1420: {
					items: 4,
					nav: true
				},
				1680: {
					items: 5,
					nav: true
				}
			}
		})
	}
}
</script>
